export const labelStyle = 'text-raisin-black text-sm block mt-4 text-left';

export const labelStyleFirst = 'text-raisin-black text-sm block mt-6 text-left';

export const inputField =
  'bg-white mt-1 font-regular border-platinum border-2 focus:border-violet-blue w-full py-2 px-3 text-base leading-tight rounded-xl shadow-sm';

export const mainButton =
  'bg-nue-blue hover:bg-violet-blue text-white font-bold py-2 rounded-xl uppercase h-10 w-3/5 min-w-[200px]';

export const secondaryButton =
  'flex items-center hover:bg-ghost-white font-bold rounded-xl w-3/5 py-2 bg-lavender mt-2 cursor-pointer justify-center h-10 min-w-[200px]';

export const secondaryButtonText = 'uppercase text-sm text-violet-blue';

export const formTitle = 'text-3xl font-bold text-left text-nue-blue';
